export default "__VITE_ASSET__CdeD99J$__"